"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ory_editor_ui_1 = require("ory-editor-ui");
var ColorComponent = /** @class */ (function (_super) {
    __extends(ColorComponent, _super);
    function ColorComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChangePickerBackgroundColor = function (e) {
            return _this.props.onChangeBackgroundColorPreview &&
                _this.props.onChangeBackgroundColorPreview(e);
        };
        _this.handleChangePickerBackgroundColorComplete = function (e) {
            if (_this.props.onChangeBackgroundColorPreview) {
                _this.props.onChangeBackgroundColorPreview(undefined);
            }
            _this.props.onChange({ backgroundColor: e });
        };
        return _this;
    }
    ColorComponent.prototype.render = function () {
        var _a = this.props, backgroundColorPreview = _a.backgroundColorPreview, _b = _a.state.backgroundColor, backgroundColor = _b === void 0 ? this.props.defaultBackgroundColor : _b;
        return (react_1.default.createElement("div", { style: { display: 'flex' } },
            react_1.default.createElement(ory_editor_ui_1.ColorPicker, { color: backgroundColorPreview ? backgroundColorPreview : backgroundColor, onChange: this.handleChangePickerBackgroundColor, onDialogOpen: this.props.ensureModeOn, onChangeComplete: this.handleChangePickerBackgroundColorComplete, style: { margin: 'auto' } })));
    };
    return ColorComponent;
}(react_1.Component));
exports.default = ColorComponent;
//# sourceMappingURL=Color.js.map